import {RouterModule, Routes} from '@angular/router';
import {WizardComponent} from './wizard.component';
import {WizardDataResolverService} from './services/wizard-data-resolver.service';
import {MethodsResolverService} from '@providers/_resolvers/methods-resolver.service';
import {NgModule} from '@angular/core';
import {WizardService} from './services/wizard.service';
import {TechnicalDocumentsResolverService} from '@providers/_resolvers/technical-documents-resolver.service';
import {ObjectsResolverService} from '@providers/_resolvers/objects-resolver.service';
import {SpecialistsResolverService} from '@providers/_resolvers/specialists-resolver.service';
import {BusinessStructuresResolverService} from '@providers/_resolvers/business-structures-resolver.service';
import {LaboratoryDocumentsResolverService} from '@providers/_resolvers/laboratory-documents-resolver.service';
import {LaboratoryResponsibleStaffResolverService} from '@providers/_resolvers/laboratory-responsible-staff-resolver.service';
import {LaboratoryResponsibleStaffTypesResolverService} from '@providers/_resolvers/laboratory-responsible-staff-types-resolver.service';

export const WizardRoutes: Routes = [
    { path: '', children: [
        { path: '',
            component: WizardComponent,
            data: {title: 'Создание документов лаборатории'},
            resolve: {
                formValues: WizardDataResolverService,
                /**
                 * Остальные резолверы нужны исключительно для того, чтобы на момент инициализации визарда
                 * данные уже были подгружены, так как на них завязаны вычисления при инициализации
                 */
                methods: MethodsResolverService,
                objects: ObjectsResolverService,
                documents: TechnicalDocumentsResolverService,
                specialists: SpecialistsResolverService,
                businessStructures: BusinessStructuresResolverService,
                laboratoryDocuments: LaboratoryDocumentsResolverService,
                responsibleStaff: LaboratoryResponsibleStaffResolverService,
                responsibleStaffTypes: LaboratoryResponsibleStaffTypesResolverService,
            },
            canDeactivate: [WizardService]
        },
        { path: 'index', redirectTo: '', pathMatch: 'full' },
    ]}
];

@NgModule({
    imports: [
        RouterModule.forChild(WizardRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class WizardRoutingModule {
}
